import { Box } from "@mui/material";
import EmployeeList from "../components/EmployeeList";
import PageHeader from "../components/PageHeader";
import { useContent } from "../app/ContentContext";

function Staff() {
  const { staffPage } = useContent();
  return (
    <Box>
      <PageHeader title={staffPage.title} description={staffPage.description} />
      <EmployeeList />
    </Box>
  );
}

export default Staff;
